export async function getFormUrl(_name: string): Promise<string> {
  return 'http://yusuwangluo.cn/';
}